<template>
  <div class="">
    <div
      class="flex justify-center relative member-container"
      @mouseenter="handleMemberHover"
      @mouseleave="handleMemberLeave"
    >
      <img
        :ref="'img' + member.title"
        :src="member.teamconfiguration?.memberImage?.sourceUrl"
        class="member-photo"
      />
      <div :ref="member.title" class="absolute bottom-12 left-6 member-info">
        <div
          class="text-l text-left text-white member-title mt-6 mb-1 whitespace-nowrap txt-q"
        >
          {{ member.title }}
        </div>
        <div class="text-t text-left text-white mb-4">
          <b>{{ member?.teamconfiguration?.position }}</b>
        </div>
      </div>
    </div>

    <div v-if="from === 'contact'" class="text-t text-center mb-1">
      {{ member?.teamconfiguration?.email }}
    </div>
    <div v-if="from === 'contact'" class="text-center">
      {{ member?.teamconfiguration?.phone }}
    </div>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  name: "NewTeamMember",
  props: {
    member: {
      type: Object,
      required: true,
    },
    from: {
      type: String,
      default: "",
    },
  },
  mounted() {
    // gsap.from('.member-info', {
    //     opacity: 0,
    // });
  },
  methods: {
    handleMemberHover() {
      gsap.to(this.$refs["img" + this.member.title], {
        scale: 1.05,
        filter: "brightness(0.8)",
      });
      gsap.to(this.$refs[this.member.title], {
        opacity: 1,
        bottom: 24,
      });
    },
    handleMemberLeave() {
      gsap.to(this.$refs["img" + this.member.title], {
        scale: 1,
        filter: "brightness(1)",
      });
      gsap.to(this.$refs[this.member.title], {
        opacity: 0,
        bottom: 0,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.member-container {
  width: 390px;
  height: 585px;
  border-radius: 16px;
  overflow: hidden;

  @media screen and (max-width: 1280px) {
    width: 100%;
    min-height: 430px;
    height: 100%;
    border-radius: 16px;
  }
  .member-photo {
    filter: brightness(1);
    object-fit: cover;
    width: 100%;
  }
}

.member-info {
  opacity: 0;
  bottom: 0;
}
</style>
